import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.RESET = function (state, payload) {
  state[payload] = {
    id: null,
    company: {
      id: null,
      files: {}
    }
  }
}
mutations.RESET_COND = function (state, payload) {
  state.cond[payload] = { user_role: payload }
}
mutations.EDIT_USER = function (state, payload) {
  state[payload[0]] = payload[1]
}
mutations.SEARCH = function (state, payload) {
  state.rows[payload.user_role] = payload.results
}

const state = {
  rows: {
    SC: {
      official: [],
      pending: []
    },
    TC: {
      official: [],
      pending: []
    }
  },
  tcRow: {
    id: null,
    company: {
      id: null,
      files: {}
    }
  },
  scRow: {
    id: null,
    company: {
      id: null,
      files: {}
    }
  },
  tabIndex: 0,
  cond: {
    SC: { user_role: 'SC' },
    TC: { user_role: 'TC' }
  }
}
const actions = {
  init: ({ commit, state }, cond) => {
    console.debug('called M0001User init')
    return client.postData({ data: { init: { api: 'M0001UserService.getInit', input: cond } } })
      .then((data) => {
        if (data.init.output.status === false) { throw new Error(data.init.output.message) } else {
          commit('FIND_ALL', data.init.output)
        }
      }).catch((err) => { throw err })
  },
  doSearch: ({ commit, state }, condition) => {
    console.debug('called M0001User search')
    return client.postData({ data: { search: { api: 'M0001UserService.doSearch', input: condition } } })
      .then((data) => {
        if (data.search.output.status === false) { throw new Error(data.search.output.message) } else {
          commit('SEARCH', {results: data.search.output, user_role: condition.user_role})
        }
      }).catch((err) => { throw err })
  },
  doDelete: ({ commit, state }, row) => {
    console.debug('called M0001User delete')
    let input = row.row
    input.cond = state.cond

    return client.postData({ data: { delete: { api: 'M0001UserService.doDelete', input: input } } })
      .then((data) => {
        commit('FIND_ALL', data.delete.output)
        commit('RESET', row.type)
      }).catch((err) => { throw err })
  },
  doApprove: ({ commit, state }, row) => {
    console.debug('called M0001User approve')
    let input = row
    input.cond = state.cond

    return client.postData({ data: { approve: { api: 'M0001UserService.doApprove', input: input } } })
      .then((data) => {
        commit('FIND_ALL', data.approve.output)
      }).catch((err) => { throw err })
  },
  doReject: ({ commit, state }, row) => {
    console.debug('called M0001User reject')
    let input = row
    input.cond = state.cond

    return client.postData({ data: { reject: { api: 'M0001UserService.doReject', input: input } } })
      .then((data) => {
        commit('FIND_ALL', data.reject.output)
      }).catch((err) => { throw err })
  },
  doSave: ({ commit, state }, row) => {
    console.debug('called M0001User save')
    return client.postData({ data: { save: { api: 'M0001UserService.doSave', input: row } } })
      .then((data) => {
        if (data.save.output.status === false) { throw new Error(data.save.output.message) } else {
          let output = data.save.output
          if (SysUtils.isEmpty(output.error)) {
            commit('FIND_ALL', data.save.output)
            return false
          } else {
            return output.error
          }
        }
      }).catch((err) => { throw err })
  },
  doEdit: ({ commit, state }, id) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { edit: { api: 'M0001UserService.doEdit', input: { id: id.id } } } })
      .then((data) => {
        if (data.edit.output.status === false) { throw new Error(data.edit.output.message) } else {
          commit('EDIT_USER', [id.userType, data.edit.output])
        }
      }).catch((err) => { throw err })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
